import API from './API.js'

export default class Log extends API {
  constructor() {
    super('log')
  }
}
